import React, { useEffect } from "react";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";

import AuthLayout from "layouts/AuthLayout";

import featureAnnouncementService from "services/featureAnnouncements";

import { useAppDispatch } from "store/hooks";
import { googleLogin } from "store/features/authSlice";
import { ModalType, openModal } from "store/features/modalSlice";
import { setNotification } from "store/features/notificationSlice";

import { AuthTokenDto } from "api";
import { routes } from "routes/routes";
import { AuthKeys } from "services/auth";
import { ONBOARDING_MODAL_CONTENT } from "shared/constants/modalContent";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";
import { FbPixelAnalyticsEvents } from "shared/constants/fb-pixel-analytics";

const Google: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const token = params.get("code");

    const googleState = params.get("state");
    const sessionState = sessionStorage.getItem(AuthKeys.GOOGLE_STATE);

    if (googleState && sessionState && googleState === sessionState && token) {
      dispatch(googleLogin({ token }))
        .unwrap()
        .then(({ isNewUser }: AuthTokenDto) => {
          analytics().sendConversionEvent(
            AnalyticsEvents.auth_google,
            { isNewUser },
            true,
          );

          if (isNewUser) {
            analytics().sendConversionEvent(
              FbPixelAnalyticsEvents.CompleteRegistration,
            );
            analytics().sendConversionEvent(FbPixelAnalyticsEvents.StartTrial);

            dispatch(openModal(ModalType.VIDEO, ONBOARDING_MODAL_CONTENT));
            ONBOARDING_MODAL_CONTENT.featureId &&
              featureAnnouncementService().recordInitialView(
                ONBOARDING_MODAL_CONTENT.featureId,
              );
          }

          navigate(routes.home, { replace: true });
        })
        .catch(() => {
          navigate(routes.auth, { replace: true });
        })
        .finally(() => {
          sessionStorage.removeItem(AuthKeys.GOOGLE_STATE);
        });
      return;
    }

    dispatch(
      setNotification({
        message: "Помилка авторизації через Google. Спробуйте ще раз.",
        severity: "error",
      }),
    );

    navigate(routes.auth, { replace: true });
  }, []);

  return (
    <AuthLayout>
      <Paper sx={{ width: { xs: "100%", sm: "480px" }, m: 2 }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="320px"
        >
          <CircularProgress />
        </Box>
      </Paper>
    </AuthLayout>
  );
};

export default Google;
